import { Controller } from "@hotwired/stimulus";

export default class SubmitStateController extends Controller {
  static values = {
    submitSelector: { type: String, default: ".post_submit" },
    visibleSelector: {
      type: String,
      default: ".add_post, .add_child_post, .progress-ring"
    },
    debug: { type: Boolean, default: true }
  };

  connect() {
    this.hasContent = false;
    this.hasMedia = false;

    this.onContentChanged = this.onContentChanged.bind(this);
    this.onMediaChanged = this.onMediaChanged.bind(this);

    this.$element = $(this.element);
    this.$form = this.$element.closest("form");

    this.$submit = this.findElements(this.submitSelectorValue);
    this.$visible = this.findElements(this.visibleSelectorValue);

    document.addEventListener("form:content-changed", this.onContentChanged);
    document.addEventListener("form:media-changed", this.onMediaChanged);

    this.updateSubmitState();
  }

  disconnect() {
    document.removeEventListener("form:content-changed", this.onContentChanged);
    document.removeEventListener("form:media-changed", this.onMediaChanged);
  }

  onContentChanged(event) {
    if (!this.isEventForMe(event)) return;

    this.hasContent = !!event.detail?.hasContent;
    this.updateSubmitState();
  }

  onMediaChanged(event) {
    if (!this.isEventForMe(event)) return;

    this.hasMedia = !!event.detail?.hasMedia;
    this.updateSubmitState();
  }

  isEventForMe(event) {
    return event.detail?.scope === this.element;
  }

  findElements(selector) {
    const $inside = this.$element.find(selector);
    return $inside.length ? $inside : this.$form.find(selector);
  }

  updateSubmitState() {
    const shouldEnable = this.hasContent || this.hasMedia;

    this.$submit
      .toggleClass("disabled", !shouldEnable)
      .prop("disabled", !shouldEnable);

    this.$visible.toggleClass("d-none", !shouldEnable);
  }
}
